import { Base64 } from 'js-base64';
import {
  GROUP_MAP_UPDATE_ADD,
  GROUP_MAP_UPDATE_DEL,
  GROUP_MAP_UPDATE_UPDATE,
  INSTALLER_MENU,
  PATHS,
  REPORT_ACTIVE_TYPE,
  REQUEST_STATUS,
  RES_STATUS,
  ROLES_KEY,
  SERVICE_RESOURCE_LIST,
  SVC_AUDIT_TYPE,
  USER_AUTHORITY_LIST,
  USER_LIST
} from '../utils/constants';
import { message, Modal } from 'antd';
import * as accountService from '../services/account';
import {
  addOrDelFile,
  addOrDelUser,
  applyBoardVersion,
  checkUser,
  conenctionTest,
  delayMeetingFun,
  deleteCleaning,
  deleteCmmaDevice,
  deleteDept,
  deleteDevice,
  deleteRoom,
  deleteService,
  deleteSvc,
  deleteSvcLevel,
  deleteZone,
  deviceList,
  dropTempSetting,
  findAllBoardVersionFnc,
  findAllSystemMultiCofig,
  findAllZone,
  findCmmaDevice,
  findRoomsByZoneId,
  getAccessTokenFuc,
  getActivityLogs,
  getAllCompanyWithOutDept,
  getAllDeptment,
  getAllHoliday,
  getAllMeetingVideo,
  getAllZone,
  getCleaningPersons,
  getDelayMeetingFun,
  getDeviceBindRoomList,
  getDisplayboardEnergy,
  getDomainInformation,
  getFindAllFileList,
  getHostPanel,
  getInfCheckTime,
  getJonzyDeviceHost,
  getLendList,
  getLevels,
  getMaxDelayTimeFunc,
  getMeetingPolicy,
  getNoticeManage,
  getNoticeState,
  getOfficeAuthInfoFuc,
  getServices,
  getSmartServiceConfig,
  getSvcTypes,
  getTempSettings,
  getUserListForPage,
  getVideosByMeetingId,
  getWeekTime,
  invitationUser,
  offLineRooms,
  pubLiveVideo,
  pubRecordVideo,
  recordActivityLog,
  saveBoardVersion,
  saveCleaningPerson,
  updatePolicyItem,
  saveDevice,
  saveMaxDelayTimeFunc,
  saveOrUpdateExchange,
  saveService,
  saveSvcLevel,
  saveTempSetting,
  saveWeekTime,
  saveZone,
  serviceLists,
  serviceOperator,
  setDisplayboardEnergy,
  setDomainInfo,
  synCmmaDevice,
  updateBillingSwitchFun,
  updateDevice,
  updateLendState,
  updateNoticeConfig,
  updateRoomManagers,
  updateVideoApply,
  updateZone,
  uploadAPK,
  userAuthorityList,
  userAuthorityOperator,
  saveInfCheckTime
} from '../services/account';
import * as cmmaService from '../services/cmmaService';
import moment from 'moment';
import openDialog from '../components/commons/ScheduleDialog';
import ReservationDialog from '../components/commons/ReservationDialog';
import PromptInfo from '../utils/promptInfo';
import _ from 'lodash';
import { getUrlParam } from '../utils/common';

const DialogType = PromptInfo.DialogType;
const DialogResult = PromptInfo.DialogResult;

function groupListToMap(groupList) {
  let groupMap = new Map();
  groupList.forEach(v => {
    groupMap.set(v.id, v);
  });
  return groupMap;
}

function groupMapUpdate(state, action) {
  let temp = _.cloneDeep(state.groupMap);
  if (action.fun === GROUP_MAP_UPDATE_DEL) {
    temp.delete(action.value);
  } else if (action.fun === GROUP_MAP_UPDATE_ADD) {
    temp.set(action.value.id, action.value);
  } else if (action.fun === GROUP_MAP_UPDATE_UPDATE) {
    temp.delete(action.value.id);
    temp.set(action.value.id, action.value);
  }
  return temp;
}

export default {
  namespace: 'account',
  state: {
    meetingReserveTimeRange:30,
    domainInfo: {},
    userInfo: {},
    userAuth: {},
    tabkey: '0',
    lastKey: '0',
    manager: [],
    book: [],
    noticeRemind: {},
    areaData: {},
    allAreaData: {},
    allAreaDataNoPermission: {},
    allDeptData: {},
    serviceType: {},
    service: {},
    operation: {},
    groupList: {},
    groupMap: [],
    groupPrivileges: null,
    checkedUser: null,
    userList: {},
    userPrivileges: null,
    setUser: {},
    setGroup: {},
    nodeLength: 0,
    deptLength: 0,
    serviceAuthorTypeList: null,
    serviceAuthorTypeInfo: null,
    isSetGroupPer: true,
    isSetUserPer: true,
    titleState: 0,
    emailError: 0,
    findAllFileListInfo: {},
    exchangeList: {},
    editExchange: {},
    uploadInfo: {},
    officeInfo: null,
    types: '',
    allDeptList: [],
    allDeptTree: [],
    meetingManagers: [],
    smartDeviceInfo: null,
    accessDeviceInfo: null,
    smartDeviceHosts: [],
    deviceInfo: {},
    rooms: [],
    roomSelectZoneId: '',
    showEditRoomModal: false,
    allCompanyData: null,
    allCompanyDataChild: {},
    allCompanyDataParent: {},
    allCompanyDataName: {},
    serviceLevels: [],
    serviceItems: {},
    allServiceItems: [],
    serviceTypes: [],
    serviceModal: false,
    svcEditObj: {},
    lendDevice: null,
    deviceModal: false,
    deviceEditObj: {},
    exchangeData: {},
    exchangeBackups: {},
    hrSystem: {},
    hrSystemLog: {},
    meetingVideos: {},
    noticeConfig: {},
    noticeKeys: [],
    displayboardEnergy: {},
    showCmmaDeviceModal: false,
    cmmaDeviceInfo: {},
    meetingPolicy: {},
    delayMeetingInfor: '',
    showSaveResult: '',
    selectYear: moment().year(),
    cleaningModal: false,
    cleaningPersonObj: {},
    cleaningPersons: [],
    maxDelayTime: '15|30|60',
    billingSwitch: 0,
    remindTime: 1,
    cospacesBulk: {},
    bindRooms: '',
    delayTime: '15',
    delayMsg: '',
    delayStatus: RES_STATUS.success,
    infraredCheckTime: 15, //红外无人检测时间
    boardVersionList: [],
    crossDaysMeetingMinDay:1//长期会议最小时间
  },
  reducers: {
    changeRooms(state, {rooms}) {
      return Object.assign({}, state, {rooms: rooms});
    },
    changeDomainData(state, {domainInfo}) {
      return Object.assign({}, state, {domainInfo: domainInfo});
    },
    changeAllZone(state, {allZone}) {
      return Object.assign({}, state, {allAreaData: allZone});
    },
    changeAllDept(state, {allDept}) {
      return Object.assign({}, state, {allDeptData: allDept});
    },
    addNode(state, {allAreaDataNoPermission}) {
      return {...state, allAreaDataNoPermission};
    },
    addDept(state, {allDeptData}) {
      return {...state, allDeptData};
    },
    changeAreaData(state, {areaData}) {
      return {...state, areaData};
    },
    changeService(state, {service}) {
      return {...state, service};
    },
    changeDeviceInfo(state, {deviceInfo}) {
      return {...state, deviceInfo};
    },
    changeOperation(state, {operation}) {
      return {...state, operation};
    },
    groupList(state, data) {
      return {...state, groupList: data.data};
    },
    groupMap(state, data) {
      return {...state, groupMap: groupListToMap(data.data.rows)};
    },
    groupMapUpdate(state, data) {
      return {...state, groupMap: groupMapUpdate(state, data.data)};
    },
    groupPrivileges(state, data) {
      return {...state, groupPrivileges: data.data};
    },
    checkedUser(state, data) {
      return {...state, checkedUser: data.data};
    },
    userList(state, data) {
      return {...state, userList: data.data};
    },
    userPrivileges(state, data) {
      return {...state, userPrivileges: data.data};
    },
    setUser(state, data) {
      return {...state, setUser: data.data};
    },
    setGroup(state, data) {
      return {...state, setGroup: data.data};
    },
    changeNodeLength(state, {nodeLength}) {
      return {...state, nodeLength};
    },
    changeDeptLength(state, {deptLength}) {
      return {...state, deptLength};
    },
    setFindAllFileListInfo(state, data) {
      return {...state, findAllFileListInfo: data.data};
    },
    isSetGroupPer(state, data) {
      return {...state, isSetGroupPer: data.data};
    },
    isSetUserPer(state, data) {
      return {...state, isSetUserPer: data.data};
    },
    changeTitleState(state, titleState) {
      return {...state, titleState: titleState.titleState};
    },
    emailError(state, {emailError}) {
      return {...state, emailError};
    },
    exchangeList(state, {exchangeList}) {
      return {...state, exchangeList};
    },
    editExchange(state, {editExchange}) {
      return {...state, editExchange};
    },
    uploadInfo(state, {uploadInfo}) {
      return {...state, uploadInfo};
    },
    setOfficeInfo(state, {officeInfo}) {
      return {...state, officeInfo};
    },
    save(state, {payload}) {
      return Object.assign({}, state, payload);
    },
    update(state, {payload}) {
      return {...state, ...payload};
    },
    updateCmmaDeviceInfo(state, {showCmmaDeviceModal, cmmaDeviceInfo}) {
      return {
        ...state,
        showCmmaDeviceModal: showCmmaDeviceModal,
        cmmaDeviceInfo: cmmaDeviceInfo
      };
    },
    setDelayTime(state, delayTime) {
      return {...state, ...delayTime};
    },
    setDelayMeetingInfor(state, delayMeetingInfor) {
      return {...state, ...delayMeetingInfor};
    },
    setDelayMsg(state, delayMsg) {
      return {...state, ...delayMsg};
    }
  },
  effects: {
    * getDisplayboardEnergy(_, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const {data} = yield call(getDisplayboardEnergy, locale);
      yield put({type: 'update', payload: {displayboardEnergy: data}});
    },
    * setDisplayboardEnergy(_, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const {messages} = yield select(state => state.i18n);
      let {mode, powerOn, powerOff} = yield select(
        state => state.account.displayboardEnergy
      );
      const {status, msg} = yield call(setDisplayboardEnergy, {
        mode,
        powerOn,
        powerOff,
        lang: locale
      });
      if (status == 0) {
        Modal.success({
          title: messages['index_save_success']
        });
      } else {
        Modal.error({
          content: msg
        });
      }
    },
    * getAllZone(undefined, {call, put, select}) {
      let {token} = yield select(state => state.login);
      const locale = yield select(state => state.i18n.locale);
      const allZone = yield call(getAllZone, {token, locale, isAll: 0});
      if (allZone && allZone.status === 1) {
        yield put({type: 'changeAllZone', allZone: null});
      } else if (allZone && allZone.status === 0) {
        yield put({type: 'changeAllZone', allZone: allZone.data});
        // 为了确定增加的node节点，先保存后台的请求长度
        let nodeLength = allZone.data.child.length;
        yield put({type: 'changeNodeLength', nodeLength: nodeLength});
      }
    },
    * getAllZoneWithoutPermission(undefined, {call, put, select}) {
      let {token} = yield select(state => state.login);
      const locale = yield select(state => state.i18n.locale);
      const allZone = yield call(getAllZone, {token, locale, isAll: 1}); //所有的
      if (allZone && allZone.status === 1) {
        yield put({
          type: 'update',
          payload: {allAreaDataNoPermission: null}
        });
      } else if (allZone && allZone.status === 0) {
        yield put({
          type: 'update',
          payload: {allAreaDataNoPermission: allZone.data}
        });
        // 为了确定增加的node节点，先保存后台的请求长度
        let nodeLength = allZone.data.child.length;
        yield put({type: 'changeNodeLength', nodeLength: nodeLength});
      }
    },
    * findRooms(
      {
        payload: {zoneId, name}
      },
      {call, put, select}
    ) {
      const locale = yield select(state => state.i18n.locale);
      let {areaData} = yield select(state => state.account);
      if (areaData == null || Object.keys(areaData).length == 0) {
        const result = yield call(getAllZone, {locale, isAll: 1});
        if (result.status === 0) {
          yield put({
            type: 'update',
            payload: {allAreaDataNoPermission: result.data}
          });
          // 为了确定增加的node节点，先保存后台的请求长度
          yield put({
            type: 'changeNodeLength',
            nodeLength: result.data.child.length
          });
          areaData = result.data;
        }
      }
      if (zoneId == 0) {
        zoneId = areaData.id;
      }
      const result = yield call(findRoomsByZoneId, {
        locale,
        zoneId: zoneId || 0,
        name: name || '',
        filterByAdminUser: 1
      });
      if (result.status === 0) {
        yield put({type: 'changeRooms', rooms: result.data});
        yield put({type: 'update', payload: {roomSelectZoneId: zoneId}});
      }
    },

    * findDeptTree(undefined, {call, put, select}) {
      let {token} = yield select(state => state.login);
      const lang = yield select(state => state.i18n.locale);
      const {status, msg, data} = yield call(getAllDeptment, {
        token,
        deptFrom: -1,
        lang
      });
      if (status === 1) {
        yield put({type: 'changeAllDept', allDept: null});
      } else if (data && status === 0) {
        yield put({type: 'changeAllDept', allDept: data});
        // 为了确定增加的node节点，先保存后台的请求长度
        let nodeLength = data.depts.length;
        yield put({type: 'changeDeptLength', deptLength: nodeLength});
      }
    },

    * findCompanyTree(undefined, {call, put, select}) {
      let {token} = yield select(state => state.login);
      const lang = yield select(state => state.i18n.locale);
      const {status, msg, data} = yield call(getAllCompanyWithOutDept, {
        token,
        deptFrom: -1,
        lang
      });
      if (status === 1) {
        yield put({type: 'update', payload: {allCompanyData: null}});
      } else if (data && status === 0) {
        const getChildArr = (node, childArr) => {
          let children = node.depts;
          children.map(ch => {
            childArr.push(ch.id + '');
            getChildArr(ch, childArr);
          });
        };
        const getChild = (node, map) => {
          let childArr = [];
          getChildArr(node, childArr);
          map[node.id + ''] = childArr;
          let children = node.depts;
          children.map(ch => {
            getChild(ch, map);
          });
        };
        let allCompanyDataChild = {};
        getChild(data, allCompanyDataChild);

        let setParent = (node, parent, map, name) => {
          map[node.id + ''] = parent.slice();
          name[node.id + ''] = node.name;
          parent.push(node.id + '');
          let children = node.depts;
          children.map(ch => {
            setParent(ch, parent.slice(), map, name);
          });
        };
        let allCompanyDataParent = {};
        let allCompanyDataName = {};
        setParent(data, [], allCompanyDataParent, allCompanyDataName);
        yield put({
          type: 'update',
          payload: {
            allCompanyData: data,
            allCompanyDataChild: allCompanyDataChild,
            allCompanyDataParent: allCompanyDataParent,
            allCompanyDataName: allCompanyDataName
          }
        });
      }
    },

    * setDomainInfo({info, locale, dispatch}, {call, put, select}) {
      const {messages} = yield select(state => state.i18n);
      if (!info.defuserPwd) {
        ReservationDialog({
          type: DialogType.INFORMATION,
          message: messages['init_password_not_null'],
          locale: locale
        });
        return;
      }
      let result = yield call(setDomainInfo, {info, locale});
      if (result && result.status === 1) {
        yield call(openDialog, {
          type: DialogType.ERROR,
          message: result.msg,
          locale: locale
        });
        yield put({type: 'changeDomainData', domainInfo: info});
      } else if (result && result.status === 0) {
        yield put({type: 'changeDomainData', domainInfo: info});
        yield call(openDialog, {
          type: DialogType.SUCCESS,
          message: result.msg,
          locale: locale
        });
      }
    },
    * deleteDept({id}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      let filter = {locale, id};
      let res = yield call(deleteDept, {filter});
      if (res.status === 0) {
        yield put({type: 'findDeptTree'});
      } else {
        yield call(openDialog, {
          type: DialogType.ERROR,
          message: res.msg,
          locale: locale
        });
      }
    },
    * deleteDeptNodeAction({node}, {put, select}) {
      const {allDeptData} = yield select(state => state.account);
      let tempAllDeptData = _.cloneDeep(allDeptData);
      if (node) {
        let deptRemoveTempNode = tempAllDeptData => {
          for (let i = 0; i < tempAllDeptData.depts.length; i++) {
            let temp = tempAllDeptData.depts[i];
            if (temp.id === node.id) {
              tempAllDeptData.depts = tempAllDeptData.depts
                .slice(0, i)
                .concat(
                  tempAllDeptData.depts.slice(
                    i + 1,
                    tempAllDeptData.depts.length
                  )
                );
            } else {
              deptRemoveTempNode(temp);
            }
          }
        };
        deptRemoveTempNode(tempAllDeptData);
      }
      yield put({type: 'addDept', allDeptData: tempAllDeptData});
    },
    // 区域维护页面
    * addAreaNode({node}, {put, select}) {
      const {allAreaDataNoPermission} = yield select(state => state.account);
      let tempAllAreaData = _.cloneDeep(allAreaDataNoPermission);
      let temp = new Array();
      temp.push({
        openInput: true,
        name: '',
        id: moment().valueOf() + 'temp'
      });
      if (node) {
        tempAllAreaData.child.map(v => {
          if (v.id === node.id) {
            v.child = temp.concat(v.child);
          }
        });
      } else {
        tempAllAreaData.child = temp.concat(tempAllAreaData.child);
      }
      yield put({type: 'addNode', allAreaDataNoPermission: tempAllAreaData});
    },
    * deleteAreaNodeAction({node}, {put, select}) {
      const {allAreaDataNoPermission} = yield select(state => state.account);
      let tempAllAreaData = _.cloneDeep(allAreaDataNoPermission);
      if (node) {
        for (let i = 0; i < tempAllAreaData.child.length; i++) {
          let temp = tempAllAreaData.child[i];
          if (temp.id === node.id) {
            tempAllAreaData.child = tempAllAreaData.child
              .slice(0, i)
              .concat(
                tempAllAreaData.child.slice(i + 1, tempAllAreaData.child.length)
              );
          } else {
            if (temp.child) {
              for (let l = 0; l < temp.child.length; l++) {
                if (temp.child[l].id === node.id) {
                  temp.child = temp.child
                    .slice(0, l)
                    .concat(temp.child.slice(l + 1, temp.child.length));
                }
              }
            }
          }
        }
      }
      yield put({type: 'addNode', allAreaDataNoPermission: tempAllAreaData});
    },
    * updateZone({data}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {roomSelectZoneId} = yield select(state => state.account);
      let res = yield call(updateZone, {filter: data});
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.MOD_REGION,
        optResult: res.status,
        actContent: `修改区域[${data.sonName}]操作成功`
      };
      if (res.status === 0) {
        message.success('修改成功!');
        yield put({type: 'getAllZone'});
        yield put({type: 'getAllZoneWithoutPermission'});
        yield put({type: 'findRooms', payload: {zoneId: roomSelectZoneId}});
        yield put({type: 'changeTitleState', titleState: 0});
      } else {
        params.actContent = `修改区域[${data.sonName}]操作失败: ${res.msg}`;
        yield call(openDialog, {
          type: DialogType.ERROR,
          message: res.msg,
          locale: locale
        });
        // 这样处理是给区域模块，编辑失败之后，再次编辑时state
        yield put({type: 'changeTitleState', titleState: 1});
      }
      yield call(recordActivityLog, params);
    },
    * saveZone({data}, {call, put, select}) {
      const {messages} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      let res = yield call(saveZone, {filter: data});
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.ADD_REGION,
        optResult: res.status,
        actContent: `新增区域[${data.sonName}]操作成功`
      };
      if (res.status === 0) {
        message.success(messages['index_save_success']);
        yield put({type: 'getAllZone'});
        yield put({type: 'getAllZoneWithoutPermission'});
      } else {
        Modal.error({content: res.msg});
        params.actContent = `新增区域[${data.sonName}]操作失败: ${res.msg}`;
      }
      yield call(recordActivityLog, params);
    },
    * deleteZone({id}, {call, put, select}) {
      const {locale, messages} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      let filter = {locale, id};
      let res = yield call(deleteZone, {filter});
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.DEL_REGION,
        optResult: res.status,
        actContent: `删除区域[ID=${id}]操作成功`
      };
      if (res.status === 0) {
        message.success(messages['index_delete_success']);
        yield put({type: 'getAllZone'});
        yield put({type: 'getAllZoneWithoutPermission'});
      } else {
        params.actContent = `删除区域[ID=${id}]操作失败: ${res.msg}`;
        Modal.error({content: res.msg});
      }
      yield call(recordActivityLog, params);
    },

    * deleteRome({roomId, name}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const {messages} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {roomSelectZoneId} = yield select(state => state.account);
      let res = yield call(deleteRoom, {locale, roomId});
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.DEL_ROOM,
        optResult: res.status,
        actContent: `删除会议室[ID=${roomId}]操作成功`
      };
      if (res.status === 0) {
        Modal.success({content: messages['meeting_room_delete_success'], okText: messages['room_edit_ok']});
        yield put({type: 'getAllZone'});
        yield put({type: 'getAllZoneWithoutPermission'});
        yield put({type: 'findRooms', payload: {zoneId: roomSelectZoneId}});
      } else {
        params.actContent = messages['meeting_room_delete_fail'] + `${res.msg}`;
        Modal.error({content: res.msg});
      }
      yield call(recordActivityLog, params);
    },
    // 批量下线会议室
    *offLineRooms({ roomIds,resolve, reject }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const { messages } = yield select(state => state.i18n);
      const { userId: optId } = yield select(state => state.login.userInfo);
      const { roomSelectZoneId } = yield select(state => state.account);
      let res = yield call(offLineRooms, { locale, roomIds, domainId:0 });
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.MOD_ROOM,
        optResult: res.status,
        actContent: `下线会议室[ID=${roomIds}]操作成功`
      };
      if (res.status === 0) {
        yield put({ type: 'getAllZone' });
        yield put({ type: 'getAllZoneWithoutPermission' });
        yield put({ type: 'findRooms', payload: { zoneId: roomSelectZoneId } });
        resolve && resolve();
      } else {
        params.actContent = messages['meeting_room_off_fail'] + `${res.msg}`;
        reject && reject(res.msg);
      }
      yield call(recordActivityLog, params);
    },
    // 服务资源
    * findAllZone({flag}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      let filter = {locale, flag};
      let res = yield call(findAllZone, {filter});
      if (res.status === 0) {
        yield put({type: 'changeAreaData', areaData: res.data});
      } else {
        yield call(openDialog, {
          type: DialogType.ERROR,
          message: res.msg,
          locale: locale
        });
      }
    },

    * changeZoneOrd({zoneIdsInOrd}, {call, put, select}) {
      if (zoneIdsInOrd) {
        const {userId: optId} = yield select(state => state.login.userInfo);
        const {status, msg} = yield call(accountService.changeZoneOrd, {
          zoneIdsInOrd
        });
        const params = {
          operatorId: optId,
          actType: REPORT_ACTIVE_TYPE.ORD_REGION,
          optResult: status,
          actContent: `修改区域排序操作成功`
        };
        if (status === 0) {
          yield put({type: 'getAllZone'});
          yield put({type: 'getAllZoneWithoutPermission'});
        } else {
          params.actContent = `修改区域排序操作失败: ${msg}`;
          Modal.error({content: msg});
        }
        yield call(recordActivityLog, params);
      }
    },
    * serviceLists({pagination, name, types}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      let res = yield call(serviceLists, {pagination, locale, name, types});
      let s = yield select(state => state.account.service);
      const service = _.cloneDeep(s);
      if (res.status === 0) {
        let {data} = res;
        data.type = '0'; //资源类型：0-会议|1-工位|2-访客|99-自定义
        if (types == 1) {
          // service
          service.serviceResourceLists = data;
        } else {
          service.serviceResourcePerLists = data;
        }
        yield put({type: 'changeService', service});
      } else {
        let e = yield call(openDialog, {
          type: DialogType.ERROR,
          message: res.msg,
          locale: locale
        });
        if (e === DialogResult.OK || e === DialogResult.CANCEL) {
          if (types == 1) {
            service.serviceResourceLists = null;
          } else {
            service.serviceResourcePerLists = null;
          }
          yield put({type: 'changeService', service});
        }
      }
    },

    * saveRoomInfo(
      {
        payload: {roomInfo, name, zoneId, resolve, reject}
      },
      {call, put, select}
    ) {
      const {locale, messages} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      roomInfo.rates = roomInfo.rates || 0;
      let res = yield call(serviceOperator, {service: roomInfo, locale});
      const params = {
        operatorId: optId,
        actType:
          roomInfo.id > 0
            ? REPORT_ACTIVE_TYPE.MOD_ROOM
            : REPORT_ACTIVE_TYPE.ADD_ROOM,
        optResult: res.status,
        actContent: `${roomInfo.id > 0 ? '修改' : '新增'}会议室[${
          roomInfo.name
          }]操作成功`
      };
      if (res.status === 0) {
        yield put({type: 'findRooms', payload: {zoneId, name}});
        yield put({type: 'update', payload: {showEditRoomModal: false}});
        Modal.success({content: messages.index_save_success, okText: messages.dialog_btn_ok});
        resolve && resolve();
      } else {
        params.actContent = `${roomInfo.id > 0 ? '修改' : '新增'}会议室[${
          roomInfo.name
          }]操作失败: ${res.msg}`;
        Modal.error({content: res.msg});
        reject && reject();
      }
      yield call(recordActivityLog, params);
    },

    * bindMangerToRooms(
      {
        payload: {manager, roomIds}
      },
      {call, put, select}
    ) {
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {messages} = yield select(state => state.i18n);

      if (!manager) {
        Modal.warning({
          content: messages['room_manage_choose_meetingroom_admin'],
          okText: messages['dialog_btn_ok']
        });
        return;
      }
      if (!roomIds || roomIds.length === 0) {
        Modal.warning({
          content: messages['meeting_placeholder_room'],
          okText: messages['dialog_btn_ok']
        });
        return;
      }

      const result = yield call(updateRoomManagers, {roomIds, manager});
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.BIND_ROOM,
        optResult: result.status,
        actContent: `会议室[ID=${roomIds}]绑定管理员[${manager}]操作成功`
      };
      if (result.status === 0) {
        Modal.success({
          content: messages['system_manage_meeting_admin_success'],
          okText: messages['dialog_btn_ok']
        });
      } else {
        params.actContent = `会议室[ID=${roomIds}]绑定管理员[${manager}]操作失败: ${
          result.msg
          }`;
        Modal.error({content: result.msg});
      }
      yield call(recordActivityLog, params);
      yield put({type: 'findRooms', payload: {zoneId: 0, name: ''}});
    },

    * deleteService({roomId, prompt, timeStamp, tt}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      let res = yield call(deleteService, {roomId, locale, tt});
      let type = DialogType.SUCCESS;
      if (res.status == 1) {
        type = DialogType.ERROR;
        prompt = res.msg;
      }
      let e = yield call(openDialog, {
        type: type,
        message: prompt,
        locale: locale
      });
      if (e === DialogResult.OK || e === DialogResult.CANCEL) {
        yield put({type: 'serviceLists', pagination: {}, name: '', types: 1});
        yield put({type: 'serviceLists', pagination: {}, name: '', types: 0});
        if (type == DialogType.SUCCESS) {
          let o = yield select(state => state.account.operation);
          let operation = _.cloneDeep(o);
          operation.operationName = timeStamp;
          operation.operationResult = res.status;
          operation.operationType = SERVICE_RESOURCE_LIST;
          yield put({type: 'changeOperation', operation});
        }
        // todo 还需要dispatch到 mainreducer里来更新数据
      }
    },

    * getUserListForPage({condition}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const result = yield call(getUserListForPage, {locale, condition});
      if (result && result.status === 1) {
        ReservationDialog({
          type: DialogType.ERROR,
          message: result.msg,
          locale: locale
        });
      }
      yield put({
        type: 'userList',
        data: result.status === 0 ? result.data : null
      });
    },
    * checkUser({user}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const result = yield call(checkUser, {locale, user});
      if (result && result.status === 1) {
        ReservationDialog({
          type: DialogType.ERROR,
          message: result.msg,
          locale: locale
        });
      }
      user.status = result.status;
      yield put({
        type: 'checkedUser',
        data: user
      }); //接口改了,因此type的值有歧义
    },
    * invitationUser({payload}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const {data, timeStamp} = payload;
      const result = yield call(invitationUser, {locale, data});
      const e = yield call(openDialog, {
        type: result.status == 0 ? DialogType.SUCCESS : DialogType.ERROR,
        message: result.status == 0 ? result.data : result.msg,
        locale: locale
      });
      if (e === DialogResult.OK || e === DialogResult.CANCEL) {
        let operation = {
          operationName: timeStamp,
          operationResult: result.status,
          operationType: 'InvitationUser'
        };
        yield put({type: 'changeOperation', operation});
      }
    },
    * addUser({payload}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const {user, saveOrUpdate, condition, timeStamp} = payload;
      const result = yield call(addOrDelUser, {locale, user, saveOrUpdate});
      if (result && result.status === 1) {
        const e = yield call(openDialog, {
          type: DialogType.ERROR,
          message: result.msg,
          locale: locale
        });
        if (e == DialogResult.OK || e == DialogResult.CANCEL) {
          // yield put({type: 'userList', data: null});
        }
      } else if (result && result.status === 0) {
        const e = yield call(openDialog, {
          type: DialogType.SUCCESS,
          message: result.msg,
          locale: locale
        });
        yield put({type: 'getAllMeetingMangers'});
        if (e == DialogResult.OK) {
          yield put({type: 'getUserListForPage', condition});
          yield put({
            type: 'userAuthorityList',
            payload: {
              searchInfo: {},
              pagination: {currentPage: 1, pageSize: 5, total: 0}
            }
          });
          let operation = {
            operationName: timeStamp,
            operationResult: result.status,
            operationType: USER_LIST
          };
          yield put({type: 'changeOperation', operation});
        }
      }
    },
    * userAuthorityList({payload}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const result = yield call(userAuthorityList, {locale, ...payload});
      if (result && result.status === 1) {
        const e = yield call(openDialog, {
          type: DialogType.ERROR,
          message: result.msg,
          locale: locale
        });
        if (e === DialogResult.OK || e === DialogResult.CANCEL) {
          yield put({
            type: 'userPrivileges',
            data: null
          });
        }
      } else if (result && result.status === 0) {
        yield put({
          type: 'userPrivileges',
          data: result.data
        });
      }
    },
    * userAuthorityOperator({payload}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const {searchInfo, pagination, prompt, timeStamp} = payload;
      const result = yield call(userAuthorityOperator, {locale, searchInfo});
      if (result && result.status === 0) {
        const e = yield call(openDialog, {
          type: DialogType.SUCCESS,
          message: prompt,
          locale: locale
        });
        if (e === DialogResult.OK) {
          yield put({
            type: 'isSetUserPer',
            data: false
          });
          yield put({
            type: 'userAuthorityList',
            payload: {
              searchInfo: {},
              pagination
            }
          });
          let operation = {
            operationName: timeStamp,
            operationResult: result.status,
            operationType: USER_AUTHORITY_LIST
          };
          yield put({type: 'changeOperation', operation});
        }
      } else if (result && result.status === 1) {
        const e = yield call(openDialog, {
          type: DialogType.ERROR,
          message: result.msg,
          locale: locale
        });
        if (e === DialogResult.OK || e === DialogResult.CANCEL) {
          yield put({
            type: 'userAuthorityList',
            payload: {
              searchInfo: {},
              pagination
            }
          });
        }
      }
    },
    * getFindAllFile({pagination}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      let data = yield call(getFindAllFileList, {pagination, locale});
      yield put({type: 'setFindAllFileListInfo', data: data});
    },
    * addFile({payload}, {call, put, select}) {
      const {locale, messages} = yield select(state => state.i18n);
      const uploadInfo = yield select(state => state.account.uploadInfo);
      let {file, saveOrUpdate} = payload;
      file = {...file, ...uploadInfo};
      if (!file.path) {
        yield call(openDialog, {
          type: DialogType.WARN,
          message: messages['upload_info_prompt'],
          locale: locale
        });
        return null;
      }
      const result = yield call(addOrDelFile, {locale, file, saveOrUpdate});
      if (result && result.status === 1) {
        yield call(openDialog, {
          type: DialogType.ERROR,
          message: result.msg,
          locale: locale
        });
      } else if (result && result.status === 0) {
        yield call(openDialog, {
          type: DialogType.SUCCESS,
          message: result.msg,
          locale: locale
        });
        const {type} = payload;
        let operation = {
          type: type,
          operationResult: result.status
        };
        yield put({type: 'changeOperation', operation});
      }
      yield put({
        type: 'getFindAllFile',
        pagination: {currentPage: 1, pageSize: 5, total: 0}
      });
    },
    * uploadFile({payload}, {call, select, put}) {
      const {locale, messages} = yield select(state => state.i18n);
      const result = yield call(uploadAPK, {...payload, locale: locale});
      if (result.status === 1) {
        yield call(openDialog, {
          type: DialogType.ERROR,
          message: result.msg,
          locale: locale
        });
      } else {
        yield put({
          type: 'uploadInfo',
          uploadInfo: (result.data && result.data.order0) || {}
        });
        yield call(openDialog, {
          type: DialogType.SUCCESS,
          message: messages['upload_success'],
          locale: locale
        });
      }
      //
    },
    * officeRegistered({registerInfo}, {call, select, put}) {
      const locale = yield select(state => state.i18n.locale);
      const token = yield select(state => state.login.token);
      const data = yield call(getAccessTokenFuc, {
        code: registerInfo.code,
        locale,
        token
      });
      yield put({type: 'getOfficeAuthInfo'});
      yield call(openDialog, {
        type: data.status === 0 ? DialogType.SUCCESS : DialogType.ERROR,
        message: data.msg,
        locale: locale
      });
      if (data.status === 0) {
        window.open(window.location, '_self').close();
      }
      //window.location.reload()
    },
    * getOfficeAuthInfo(undefined, {call, select, put}) {
      const locale = yield select(state => state.i18n.locale);
      const data = yield call(getOfficeAuthInfoFuc, {locale});
      yield put({type: 'setOfficeInfo', officeInfo: data.data});
    },
    * getAllDept(undfined, {call, put, select}) {
      let {token} = yield select(state => state.login);
      const lang = yield select(state => state.i18n.locale);
      const result = yield call(getAllDeptment, {token, deptFrom: -1, lang});
      yield put({type: 'save', payload: {allDeptList: result.data.depts}});
    },
    * getDeptTree(undfined, {call, put, select}) {
      let {token} = yield select(state => state.login);
      const lang = yield select(state => state.i18n.locale);
      const result = yield call(getAllDeptment, {token, deptFrom: -1, lang});
      yield put({type: 'save', payload: {allDeptTree: result.data.depts}});
    },
    * getAllMeetingMangers(_, {call, put, select}) {
      const {status, data} = yield call(accountService.getUsersByRoleKey, {
        roleKey: ROLES_KEY.room_admin
      });
      if (status == 0) {
        yield put({
          type: 'save',
          payload: {meetingManagers: JSON.parse(Base64.decode(data))}
        });
      } else {
        console.log('获取会议管理员信息失败');
      }
    },
    * getJonzyDeviceHost(_, {call, put, select}) {
      const {locale, messages} = yield select(state => state.i18n);
      const {status, data, msg} = yield call(getJonzyDeviceHost, {locale});
      if (status == 0 && data && data.dataList) {
        for (let item of data.dataList) {
          const {status: status2, data: data2, msg: msg2} = yield call(
            getHostPanel,
            {hostId: item.hostId, locale}
          );
          if (status2 == 0) {
            item.hostPanels = data2.dataList;
          } else {
            console.log(`获取hostPanel失败,hostId = ${item.hostId}`);
          }
        }
        yield put({
          type: 'save',
          payload: {smartDeviceHosts: data.dataList}
        });
      } else {
        console.log('获取隽智设备host出错', msg);
      }
    },
    * getSmartServiceConfig(
      {
        payload: {type}
      },
      {call, put, select}
    ) {
      const {locale, messages} = yield select(state => state.i18n);
      const {status, data, msg} = yield call(getSmartServiceConfig, {
        locale
      });
      if (status == 0) {
        let smartDeviceInfo = null;
        let accessDeviceInfo = null;
        data &&
        data.map(item => {
          if (item.type == 1) {
            //智能设备
            smartDeviceInfo = item;
          } else if (item.type == 2) {
            //微耕门禁
            accessDeviceInfo = item;
          }
        });
        if (type == 1) {
          yield put({type: 'save', payload: {smartDeviceInfo}});
        } else if (type == 2) {
          yield put({type: 'save', payload: {accessDeviceInfo}});
        } else {
          yield put({
            type: 'save',
            payload: {smartDeviceInfo, accessDeviceInfo}
          });
        }
      } else {
        console.log('获取智能设备信息失败', msg);
      }
    },
    * findDeviceLists({types}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      let res = yield call(deviceList, {types, locale});
      let ds = yield select(state => state.account.deviceInfo);
      const deviceInfo = _.cloneDeep(ds);
      if (res.status === 0) {
        let {data} = res;
        if (1 == types) {
          deviceInfo.fixedList = data;
        } else if (2 == types) {
          deviceInfo.mobileList = data;
        } else if (0 == types) {
          deviceInfo.roomDeviceList = data;
        }
        yield put({type: 'changeDeviceInfo', deviceInfo});
      } else {
        let e = yield call(openDialog, {
          type: DialogType.ERROR,
          message: res.msg,
          locale: locale
        });
        if (e === DialogResult.OK || e === DialogResult.CANCEL) {
          if (1 == types) {
            deviceInfo.fixedList = {};
          } else if (2 == types) {
            deviceInfo.mobileList = {};
          } else if (0 == types) {
            deviceInfo.roomDeviceList = {};
          }
          yield put({type: 'changeDeviceInfo', deviceInfo});
        }
      }
    },
    * deviceBindRooms({deviceId}, {call, put, select}) {
      const {locale} = yield select(state => state.i18n);
      const {status, data} = yield call(getDeviceBindRoomList, locale, deviceId);
      if (status === REQUEST_STATUS.success && data && data.length > 0) {
        yield put({type: 'update', payload: {bindRooms: data.map(d => d.roomName).join(', ')}})
      } else {
        yield put({type: 'update', payload: {bindRooms: ''}})
      }
    },
    * deleteDevice({deviceId, resolve, reject}, {call, put, select}) {
      const {locale, messages} = yield select(state => state.i18n);
      const {bindRooms} = yield select(state => state.account);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.DEL_DEVICE,
        optResult: REQUEST_STATUS.success,
        actContent: `删除设备[ID=${deviceId}]操作成功`
      };
      if (bindRooms !== '') {
        const msgBody = [];
        const pl35 = {paddingLeft: '35px'};
        const rmNm = {
          maxWidth: '90%',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis'
        }
        msgBody.push(<p style={pl35}>{messages['device_manage_confirm_occupied']}</p>);
        msgBody.push(<p style={{...pl35, ...rmNm}}>{bindRooms}</p>);
        msgBody.push(<p style={pl35}>{messages['device_manage_confirm_cannot_delete']}</p>);
        Modal.error({
          content: msgBody,
          onOk: () => {
          }
        })
        yield put({type: 'update', payload: {bindRooms: ''}});
        return;
      } else {
        const filter = {locale, deviceId};
        const {status, msg} = yield call(deleteDevice, {filter});
        if (status === REQUEST_STATUS.success) {
          resolve && resolve();
        } else {
          params.optResult = REQUEST_STATUS.failure;
          params.actContent = `删除设备[ID=${deviceId}]操作失败: ${msg}`;
          reject && reject(msg);
        }
        yield call(recordActivityLog, params);
      }
    },
    * getAllDeviceInfo(_, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const {status, data, msg} = yield call(deviceList, {types: '-1', locale});
      const deviceInfo = {
        fixedList: [],
        mobileList: []
      };
      if (status === 0) {
        data && data.forEach(d => {
          if (d.type === 0) {
            deviceInfo.fixedList.push(d)
          } else if (d.type === 2) {
            deviceInfo.mobileList.push(d)
          }
        })
      } else {
        yield call(openDialog, {
          type: DialogType.ERROR,
          message: msg,
          locale: locale
        })
      }
      yield put({type: 'changeDeviceInfo', deviceInfo});
    },
    * saveTempSetting({payload}, {call, put, select}) {
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {messages} = yield select(state => state.i18n);
      const {status, msg} = yield call(saveTempSetting, payload);
      const params = {
        operatorId: optId,
        actType:
          payload.tempId > 0
            ? REPORT_ACTIVE_TYPE.MOD_BOARD_TEMP
            : REPORT_ACTIVE_TYPE.ADD_BOARD_TEMP,
        optResult: status,
        actContent: `${payload.tempId > 0 ? '修改' : '新增'}预约屏模板[${
          payload.tempName
          }]操作成功`
      };
      if (status === 0) {
        const {pageNo: page} = yield select(
          state => state.account.tempSettings
        );
        Modal.success({
          title: messages['index_save_success'],
          okText: messages['modal_manage_btn_ok']
        });
        yield put({type: 'findRooms', payload: {zoneId: 0, name: ''}});
        yield put({type: 'getTempSettings', page});
      } else {
        params.actContent = `${
          payload.tempId > 0 ? '修改' : '新增'
          }预约屏模板[${payload.tempName}]操作失败: ${msg}`;
        Modal.error({
          title: messages.index_save_failed,
          okText: messages['modal_manage_btn_ok']
        });
      }
      yield call(recordActivityLog, params);
    },
    * getTempSettings({page}, {call, put}) {
      const {data, status, msg} = yield call(getTempSettings, page);
      if (status === 0) {
        yield put({type: 'update', payload: {tempSettings: data}});
      } else {
        Modal.error({content: msg});
        yield put({type: 'update', payload: {tempSettings: []}});
      }
    },
    * dropTempSettings({tempId, tempName}, {select, call, put}) {
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {status, msg} = yield call(dropTempSetting, tempId);
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.DEL_BOARD_TEMP,
        optResult: status,
        actContent: `删除预约屏模板[${tempName}]操作成功`
      };
      if (status === 0) {
        const {pageNo, total, pageSize} = yield select(
          state => state.account.tempSettings
        );
        const pageCount = Math.ceil((total - 1) / pageSize);
        const page = pageNo > pageCount ? pageCount : pageNo;
        Modal.success({content: '预约屏模板删除成功', okText: '确认'});
        yield put({type: 'findRooms', payload: {zoneId: 0, name: ''}});
        yield put({type: 'getTempSettings', page});
      } else {
        params.actContent = `删除预约屏模板[${tempName}]操作失败: ${msg}`;
        Modal.error({content: msg});
      }
      yield call(recordActivityLog, params);
    },
    * getAllLevels(_, {call, put, select}) {
      const lang = yield select(state => state.i18n.locale);
      const {status, data} = yield call(getLevels, {lang});
      if (status === 0 && data) {
        yield put({type: 'update', payload: {serviceLevels: data}});
      }
    },
    * getAllSvc({payload}, {call, put, select}) {
      const lang = yield select(state => state.i18n.locale);
      const {data, status} = yield call(getServices, {
        lang,
        pageNo: payload.pageNo,
        pageSize: payload.pageSize
      });
      if (status === 0 && data) {
        yield put({
          type: 'update',
          payload: {serviceItems: data}
        });
      }
    },
    * getLendList(
      {
        payload: {current = 1, pageSize = 10}
      },
      {call, put, select}
    ) {
      const result = yield call(getLendList, {
        pageNo: current,
        pageSize: pageSize
      });
      if (result.status === 0 && result.data) {
        yield put({type: 'update', payload: {lendDevice: result.data}});
      }
    },
    * getAllSvcNoPage(_, {call, put, select}) {
      const lang = yield select(state => state.i18n.locale);
      const {data, status} = yield call(getServices, {
        lang,
        pageNo: 1,
        pageSize: 999
      });
      if (status === 0 && data && data.list) {
        yield put({
          type: 'update',
          payload: {allServiceItems: data.list}
        });
      }
    },
    * getAllSvcType(_, {call, put, select}) {
      const lang = yield select(state => state.i18n.locale);
      const {data, status} = yield call(getSvcTypes, {lang});
      if (status === 0 && data) {
        yield put({
          type: 'update',
          payload: {serviceTypes: data}
        });
      }
    },
    * getAllCleaningPersons(_, {call, put, select}) {
      const lang = yield select(state => state.i18n.locale);
      const {data, status} = yield call(getCleaningPersons, {lang});
      if (status === 0 && data) {
        yield put({
          type: 'update',
          payload: {cleaningPersons: data, cleaningModal: false}
        });
      }
    },
    * setSvcLevel(_, {call, put, select}) {
      const {locale, messages} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {svcEditObj, serviceLevels} = yield select(
        state => state.account
      );
      if (!svcEditObj.name) {
        Modal.error({content: messages['service_level_error']});
        return false;
      }
      if (
        serviceLevels &&
        serviceLevels.some(item => {
          return (
            item.id !== svcEditObj.id &&
            String(item.name) === String(svcEditObj.name)
          );
        })
      ) {
        Modal.error({content: messages['service_level_same']});
        return false;
      }
      if (!(svcEditObj.svcs && svcEditObj.svcs.length > 0)) {
        Modal.error({content: messages['service_svcIds_error']});
        return false;
      }
      let keys = [];
      if (svcEditObj.svcs) {
        svcEditObj.svcs.map(s => keys.push(String(s.id)));
      }
      let data = {
        id: svcEditObj.id || 0,
        name: svcEditObj.name || '',
        remark: svcEditObj.remark || '',
        auditType: svcEditObj.auditType || SVC_AUDIT_TYPE.no,
        svcIds: keys.join(';')
      };
      const {status, msg} = yield call(saveSvcLevel, {lang: locale, data});
      const params = {
        operatorId: optId,
        actType:
          data.id > 0
            ? REPORT_ACTIVE_TYPE.MOD_SRV_LV
            : REPORT_ACTIVE_TYPE.ADD_SRV_LV,
        optResult: status,
        actContent: `${data.id > 0 ? '编辑' : '新增'}会议服务等级[${
          data.name
          }]操作成功`
      };
      if (status === 0) {
        yield put({type: 'getAllLevels'});
        Modal.success({content: messages['index_save_success']});
        yield put({type: 'update', payload: {serviceModal: false}});
      } else {
        params.actContent = `${data.id > 0 ? '编辑' : '新增'}会议服务等级[${
          data.name
          }]操作失败: ${msg}`;
        Modal.error({content: msg});
      }
      yield call(recordActivityLog, params);
    },
    * setService(_, {call, put, select}) {
      const {locale, messages} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {svcEditObj} = yield select(state => state.account);
      if (!svcEditObj.name) {
        Modal.error({content: messages['service_item_error']});
        return false;
      }
      if (!svcEditObj.price) {
        Modal.error({content: messages['service_price_error']});
        return false;
      }
      if (!svcEditObj.unit) {
        Modal.error({content: messages['service_unit_error']});
        return false;
      }
      if (!svcEditObj.type) {
        Modal.error({content: messages['service_type_error']});
        return false;
      }
      if (Number(svcEditObj.describeState) === 0 && !svcEditObj.describe) {
        Modal.error({content: messages['service_remark_error']});
        return false;
      }
      let data = {
        id: svcEditObj.id || 0,
        name: svcEditObj.name || '',
        describeRemark: svcEditObj.describeRemark || '',
        price: svcEditObj.price || '',
        unit: svcEditObj.unit || '',
        typeId: svcEditObj.type ? svcEditObj.type.id : '',
        countState: Number(svcEditObj.countState) === 0 ? 0 : 1,
        describeState: Number(svcEditObj.describeState) === 0 ? 0 : 1,
        describe: svcEditObj.describe || '',
        uploadState: Number(svcEditObj.uploadState) === 0 ? 0 : 1
      };
      const {status, msg} = yield call(saveService, {lang: locale, data});
      const params = {
        operatorId: optId,
        actType:
          data.id > 0
            ? REPORT_ACTIVE_TYPE.MOD_SRV_ITEM
            : REPORT_ACTIVE_TYPE.ADD_SRV_ITEM,
        optResult: status,
        actContent: `${data.id > 0 ? '编辑' : '新增'}会议服务项[${
          data.name
          }]操作成功`
      };
      if (status === 0) {
        const {serviceItems} = yield select(state => state.account);
        const {total = 0, pageNo, pageSize = 10} = serviceItems;
        let num = pageNo;
        if (!Boolean(svcEditObj.id)) {
          num =
            Number(total) % Number(pageSize) === 0
              ? Math.ceil(total / pageSize) + 1
              : Math.ceil(total / pageSize);
        }
        yield put({
          type: 'getAllSvc',
          payload: {pageNo: num, pageSize: pageSize}
        });
        yield put({type: 'getAllSvcNoPage'});
        Modal.success({content: messages['index_save_success']});
        yield put({type: 'update', payload: {serviceModal: false}});
      } else {
        params.actContent = `${data.id > 0 ? '编辑' : '新增'}会议服务项[${
          data.name
          }]操作失败: ${msg}`;
        Modal.error({content: msg});
      }
      yield call(recordActivityLog, params);
    },
    * setCleaningPerson(_, {call, put, select}) {
      const {locale, messages} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {cleaningPersonObj} = yield select(
        state => state.account
      );
      let data = {
        id: cleaningPersonObj.id || 0,
        name: cleaningPersonObj.name || '',
        phone: cleaningPersonObj.phone || '',
        email: cleaningPersonObj.email || ''
      };
      const {status, msg} = yield call(saveCleaningPerson, {lang: locale, data});
      const params = {
        operatorId: optId,
        actType:
          data.id > 0
            ? REPORT_ACTIVE_TYPE.MOD_SRV_LV
            : REPORT_ACTIVE_TYPE.ADD_SRV_LV,
        optResult: status,
        actContent: `${data.id > 0 ? '编辑' : '新增'}保洁人员[${
          data.name
          }]操作成功`
      };
      if (status === 0) {
        yield put({type: 'getAllCleaningPersons'});
        Modal.success({content: messages['index_save_success']});
        yield put({type: 'update', payload: {cleaningModal: false}});
      } else {
        params.actContent = `${data.id > 0 ? '编辑' : '新增'}保洁人员[${
          data.name
          }]操作失败: ${msg}`;
        Modal.error({content: msg});
      }
      yield call(recordActivityLog, params);
    },
    * deleteCleaning({id}, {call, put, select}) {
      const {locale, messages} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {status, msg} = yield call(deleteCleaning, {lang: locale, id});
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.DEL_SRV_LV,
        optResult: status,
        actContent: `删除保洁员[ID=${id}]操作成功`
      };
      if (status === 0) {
        yield put({type: 'getAllCleaningPersons'});
        Modal.success({content: messages['index_delete_success']});
      } else {
        params.actContent = `删除保洁员[ID=${id}]操作失败: ${
          msg
          }`;
        Modal.error({content: msg});
      }
      yield call(recordActivityLog, params);
    },
    * deleteLevel({id}, {call, put, select}) {
      const {locale, messages} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {status, msg} = yield call(deleteSvcLevel, {lang: locale, id});
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.DEL_SRV_LV,
        optResult: status,
        actContent: `删除会议服务等级[ID=${id}]操作成功`
      };
      if (status === 0) {
        yield put({type: 'getAllLevels'});
        Modal.success({content: messages['index_delete_success']});
      } else {
        params.actContent = `删除会议服务等级[ID=${id}]操作失败: ${
          msg
          }`;
        Modal.error({content: msg});
      }
      yield call(recordActivityLog, params);
    },
    * delSvc({id}, {call, put, select}) {
      const {locale, messages} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {status, msg} = yield call(deleteSvc, {lang: locale, id});
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.DEL_SRV_ITEM,
        optResult: status,
        actContent: `删除会议服务项[ID=${id}]操作成功`
      };
      if (status === 0) {
        const {serviceItems} = yield select(state => state.account);
        const {total = 0, pageNo, pageSize = 10} = serviceItems;
        let num =
          Math.ceil(total / pageSize) === pageNo && total % pageSize === 1
            ? pageNo - 1
            : pageNo;
        yield put({
          type: 'getAllSvc',
          payload: {pageNo: num, pageSize: pageSize}
        });
        yield put({type: 'getAllSvcNoPage'});
        Modal.success({content: messages['index_delete_success']});
      } else {
        params.actContent = `删除会议服务项[ID=${id}]操作失败: ${
          msg
          }`;
        Modal.error({content: msg});
      }
      yield call(recordActivityLog, params);
    },
    * getExchangeForm({payload}, {call, put, select}) {
      const {locale} = yield select(state => state.i18n);
      const {data = {}, status} = yield call(findAllSystemMultiCofig, {
        ...payload,
        locale
      });
      if (status === 0) {
        yield put({
          type: 'update',
          payload: {
            exchangeData: data ? data : {},
            exchangeBackups: data ? data : {}
          }
        });
      }
    },
    * setExchange({operateType}, {call, put, select}) {
      const {locale, messages} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {exchangeData} = yield select(state => state.account);
      exchangeData.operateType = operateType;
      const result = yield call(saveOrUpdateExchange, {exchangeData, locale});
      let optStr = '';
      if (operateType === 0) {
        optStr = '保存Exchange配置';
      } else if (operateType === 1) {
        optStr = '关闭Exchange连接';
      }
      const params = {
        operatorId: optId,
        actType:
          operateType === 0
            ? REPORT_ACTIVE_TYPE.SAVE_EXCH
            : REPORT_ACTIVE_TYPE.DIS_CONN_EXCH,
        optResult: result.status,
        actContent: `${optStr}操作成功`
      };
      if (result.status === 0) {
        yield put({
          type: 'getExchangeForm',
          payload: {
            currentPage: 1,
            pageSize: 5,
            type: 1,
            status: -1,
            category: 0
          }
        });
        Modal.success({content: `${optStr}操作成功`});
      } else {
        params.actContent = `${optStr}操作失败: ${result.msg}`;
        Modal.error({content: result.msg});
      }
      yield call(recordActivityLog, params);
    },
    * testExchange({}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const {messages} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const exchange = yield select(state => state.account.exchangeData);
      const result = yield call(conenctionTest, {exchange, locale});
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.CONN_EXCH,
        optResult: result.status,
        actContent: `打开Exchange连接操作成功`
      };
      if (result.status === 0) {
        yield put({
          type: 'update',
          payload: {exchangeData: result.data, exchangeBackups: result.data}
        });
        Modal.success({content: messages['meeting_services_info_value6']});
      } else {
        params.actContent = `打开Exchange连接操作失败: ${result.msg}`;
        Modal.error({content: result.msg});
      }
      yield call(recordActivityLog, params);
    },
    * updateLendState(
      {
        payload: {id, lendState, current, pageSize}
      },
      {call, put, select}
    ) {
      const {locale: lang} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {messages} = yield select(state => state.i18n);
      const result = yield call(updateLendState, {id, lendState, lang});
      let stateStr = '';
      if (lendState === 1) {
        stateStr = '借用';
      } else if (lendState === 2) {
        stateStr = '归还';
      }
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.LEND_STATE,
        optResult: result.status,
        actContent: `设备[ID=${id}]进行[${stateStr}]操作成功`
      };
      if (result.status === 0) {
        yield put({type: 'getLendList', payload: {current, pageSize}});
        Modal.success({content: messages['meeting_services_info_value7']});
      } else {
        params.actContent = `设备[ID=${id}]进行[${stateStr}]操作失败: ${
          result.msg
          }`;
        Modal.error({content: result.msg});
      }
      yield call(recordActivityLog, params);
    },
    * activityLogs({payload}, {call, put}) {
      const params = {
        operatorId: payload.operatorId || '',
        actType: payload.actType || '',
        startTime: payload.startTime || '',
        endTime: payload.endTime || '',
        pageNo: payload.pageNo || 1,
        pageSize: 15
      };
      const result = yield call(getActivityLogs, params);
      if (result.status === 0 && result.data) {
        yield put({type: 'update', payload: {logManage: result.data}});
      } else {
        Modal.error({content: result.msg});
      }
    },
    * getNoticeManage(_, {call, put, select}) {
      const {locale: lang} = yield select(state => state.i18n);
      const result = yield call(getNoticeManage, lang);
      if (result.status === 0 && result.data) {
        const {
          noticeConfig = {},
          noticeKeys = [],
          fullKeys = [],
          meetingPolicy = {billingSwitch:0,crossDaysMeetingMinDay:1},
        } = result.data;
        const {billingSwitch,crossDaysMeetingMinDay,meetingReserveTimeRange} = meetingPolicy;
        yield put({
          type: 'update',
          payload: {noticeConfig, noticeKeys: fullKeys,billingSwitch,crossDaysMeetingMinDay,meetingReserveTimeRange}
        });
      } else {
        Modal.error({content: result.msg});
      }
    },
    * updateNoticeConfig({noticeConfig}, {call, put, select}) {
      const {locale: lang} = yield select(state => state.i18n);
      const result = yield call(updateNoticeConfig, noticeConfig, lang);
      if (result.status === 0 && result.data) {
        yield put({type: 'update', payload: {noticeConfig}});
      } else {
        Modal.error({content: result.msg});
      }
    },
    * updateBillingSwitch({value = 0}, {call, put, select}) {
      const {locale} = yield select(state => state.i18n);
      const result = yield call(updateBillingSwitchFun, {value,locale});
      if (result.status === 0) {
        yield put({type: 'update', payload: {billingSwitch: value}});
      } else {
        Modal.error({content: result.msg});
      }
    },
    * getInfraredCheckTime(_, {call, put, select}) {
      const {locale: lang} = yield select(state => state.i18n);
      const {data, status, msg} = yield call(getInfCheckTime, lang);
      if (status === RES_STATUS.success) {
        yield put({type: 'update', payload: {infraredCheckTime: Number(data)}});
      } else {
        message.error(msg);
      }
    },
    * saveInfraredCheckTime(_, {call, put, select}) {
      const {locale: lang} = yield select(state => state.i18n);
      const {infraredCheckTime} = yield select(state => state.account);
      const {status, msg} = yield call(saveInfCheckTime, {lang, checkTime: infraredCheckTime});
      if (status === RES_STATUS.success) {
        message.success(msg);
      } else {
        message.error(msg);
      }
    },
    * saveOrUpdatePolicyItem({key,value},{call,put,select}){
      const {locale: lang,messages} = yield select(state => state.i18n);
      const {status, msg} = yield call(updatePolicyItem, {lang, key ,value});
      if (status === RES_STATUS.success) {
        Modal.success({
          title: messages['index_save_success']
        });
      } else {
        Modal.error({content: msg});
      }
    },
    * getAllHoliday({year}, {call, put, select}) {
      const {locale: lang} = yield select(state => state.i18n);
      const result = yield call(getAllHoliday, lang, year);
      if (result.status === 0 && result.data) {
        yield put({type: 'update', payload: {holidays: result.data}});
      } else {
        Modal.error({content: result.msg});
      }
    },
    * getWeekTime({year}, {call, put, select}) {
      const {locale: lang} = yield select(state => state.i18n);
      const result = yield call(getWeekTime, lang, year);
      if (result.status === 0 && result.data) {
        yield put({
          type: 'update',
          payload: {weekTime: result.data, selectYear: year}
        });
      } else {
        Modal.error({content: result.msg});
      }
    },
    * switchYear({year}, {put}) {
      yield put({type: 'getWeekTime', year});
      yield put({type: 'getAllHoliday', year});
    },
    * saveWeekTime({payload}, {call, put, select}) {
      const {locale: lang} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {messages} = yield select(state => state.i18n);
      const params = {...payload, lang};
      const result = yield call(saveWeekTime, params);
      const logParams = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.HOLIDAY_MANAGE,
        optResult: result.status,
        actContent: `设置${params.year}年工作日及工作时间操作成功`
      };
      if (result.status === 0) {
        Modal.success({
          title: messages['index_save_success']
        });
        // yield put({type: 'update', payload: {showSaveResult: "保存成功"}});
        yield put({type: 'getWeekTime', year: params.year});
        yield put({type: 'getAllHoliday', year: params.year});
      } else {
        logParams.actContent = `设置${params.year}年工作日及工作时间操作失败: ${
          result.msg
          }`;
        // Modal.error({content: result.msg});
        // yield put({type: 'update', payload: {showSaveResult: "保存失败"}});
        Modal.error({
          title: messages.index_save_failed
        });
      }
      yield call(recordActivityLog, logParams);
    },
    * clickSingleDay({payload}, {call, put, select}) {
      const {locale: lang} = yield select(state => state.i18n);
      const {userId: optId} = yield select(state => state.login.userInfo);
      const params = {...payload, lang};
      let result;
      const logMsg = [`将${params.holidayTime}改为`];
      if (params.isHoliday) {
        // 设置为工作日
        result = yield call(accountService.setWorkDay, params);
        logMsg.push('工作日');
      } else {
        // 设置为节假日
        result = yield call(accountService.setHoliday, params);
        logMsg.push('节假日');
      }
      const logParams = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.HOLIDAY_MANAGE,
        optResult: result.status,
        actContent: `${logMsg.join('')}操作成功`
      };
      if (result.status === 0 && result.data) {
        yield put({type: 'update', payload: {holidays: result.data}});
      } else {
        logParams.actContent = `${logMsg.join('')}操作失败: ${result.msg}`;
        Modal.error({content: result.msg});
      }
      yield call(recordActivityLog, logParams);
    },
    * saveDevice({deviceInfo, resolve, reject}, {call, put, select}) {
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {locale: lang} = yield select(state => state.i18n);
      let params = {};
      if (deviceInfo.id > 0) {
        const result = yield call(updateDevice, {deviceInfo, lang});
        params = {
          operatorId: optId,
          actType: REPORT_ACTIVE_TYPE.MOD_DEVICE,
          optResult: REQUEST_STATUS.success,
          actContent: `编辑设备[${deviceInfo.name}]操作成功`
        }
        if (result.status === REQUEST_STATUS.success) {
          resolve && resolve();
        } else {
          params.optResult = REQUEST_STATUS.failure;
          params.actContent = `编辑设备[${deviceInfo.name}]操作失败: ${result.msg}`;
          reject && reject(result.msg);
        }
      } else {
        const result = yield call(saveDevice, {deviceInfo, lang});
        params = {
          operatorId: optId,
          actType: REPORT_ACTIVE_TYPE.ADD_DEVICE,
          optResult: result.status,
          actContent: `新增设备[${deviceInfo.name}]操作成功`
        }
        if (result.status === REQUEST_STATUS.success) {
          resolve && resolve();
        } else {
          params.actContent = `新增设备[${deviceInfo.name}]操作失败: ${result.msg}`;
          reject && reject(result.msg);
        }
      }
      yield call(recordActivityLog, params);
    },
    * getAllMeetingVideo(
      {
        payload: {current = 1, pageSize = 10}
      },
      {call, put, select}
    ) {
      const {status, data} = yield call(getAllMeetingVideo, {
        pageNo: current,
        pageSize: pageSize
      });
      if (status === 0 && data) {
        yield put({type: 'update', payload: {meetingVideos: data}});
      } else {
        console.log('获取会议录播申请失败');
      }
    },
    * updateMeetingVideoApply(
      {meetingVideo, resolve, reject},
      {call, put, select}
    ) {
      const {userId: optId} = yield select(state => state.login.userInfo);
      const result = yield call(updateVideoApply, {meetingVideo});
      const params = {
        operatorId: optId,
        actType: REPORT_ACTIVE_TYPE.MOD_VIDEO_SETTING,
        optResult: result.status,
        actContent: `修改会议[ID=${meetingVideo.meetingId}]直录播申请操作成功`
      };
      if (result.status === 0) {
        resolve && resolve();
      } else {
        params.actContent = `修改会议[ID=${
          meetingVideo.meetingId
          }]直录播申请操作失败: ${result.msg}`;
        reject && reject(result.msg);
      }
      yield call(recordActivityLog, params);
    },
    * publicLiveVideo({params, resolve, reject}, {call, put, select}) {
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {status, msg} = yield call(pubLiveVideo, {params});
      const sendParams = {
        operatorId: optId,
        actType:
          params.action === 1
            ? REPORT_ACTIVE_TYPE.PUBLIC_LIVE_VIDEO
            : REPORT_ACTIVE_TYPE.CANCEL_LIVE_VIDEO,
        optResult: status,
        actContent: `会议[ID=${params.meetingId}]${
          params.action === 1 ? '发布' : '取消'
          }直播成功`
      };
      if (status === 0) {
        resolve && resolve();
      } else {
        sendParams.actContent = `会议[ID=${params.meetingId}]${
          params.action === 1 ? '发布' : '取消'
          }直播失败: ${msg}`;
        reject && reject(msg);
      }
      yield call(recordActivityLog, sendParams);
    },
    * publicRecordVideo({params, resolve, reject}, {call, put, select}) {
      const {userId: optId} = yield select(state => state.login.userInfo);
      const {status, msg} = yield call(pubRecordVideo, {params});
      const sendParams = {
        operatorId: optId,
        actType:
          params.action === 1
            ? REPORT_ACTIVE_TYPE.PUBLIC_RECORD_VIDEO
            : REPORT_ACTIVE_TYPE.CANCEL_RECORD_VIDEO,
        optResult: status,
        actContent: `会议[ID=${params.meetingId}]${
          params.action === 1 ? '发布' : '取消'
          }录播成功`
      };
      if (status === 0) {
        resolve && resolve();
      } else {
        sendParams.actContent = `会议[ID=${params.meetingId}]${
          params.action === 1 ? '发布' : '取消'
          }录播失败: ${msg}`;
        reject && reject(msg);
      }
      yield call(recordActivityLog, sendParams);
    },
    * getVideosByMeetingId(
      {resolve, reject, meetingId},
      {call, put, select}
    ) {
      const result = yield call(getVideosByMeetingId, {meetingId});
      if (result.status == 0) {
        resolve && resolve(result.data);
      } else {
        reject && reject(result.msg);
      }
    },
    * getCmmaDevice({cmmaRoomId}, {call, put}) {
      let cmmaDeviceInfo = {},
        showCmmaDeviceModal = true;
      if (cmmaRoomId && cmmaRoomId !== -1) {
        let {data} = yield call(findCmmaDevice, {cmmaRoomId});
        if (data) {
          cmmaDeviceInfo = data;
        } else {
          cmmaDeviceInfo = {cmmaRoomId: cmmaRoomId};
        }
      }
      yield put({
        type: 'updateCmmaDeviceInfo',
        showCmmaDeviceModal,
        cmmaDeviceInfo
      });
    },
    * synCmmaDevice({payload, resolve, reject}, {call, put}) {
      const {status} = yield call(synCmmaDevice, payload);
      if (0 === status) {
        yield put({
          type: 'updateCmmaDeviceInfo',
          showCmmaDeviceModal: false,
          cmmaDeviceInfo: {}
        });
        resolve && resolve();
      } else {
        reject && reject();
      }
    },
    * deleteCmmaDevice({cmmaRoomId, resolve, reject}, {call, put}) {
      const {status} = yield call(deleteCmmaDevice, cmmaRoomId);
      if (0 === status) {
        yield put({
          type: 'updateCmmaDeviceInfo',
          showCmmaDeviceModal: false,
          cmmaDeviceInfo: {}
        });
        resolve && resolve();
      } else {
        reject && reject();
      }
    },
    * getMeetingPolicy(_, {select, call, put}) {
      const lang = yield select(state => state.i18n.locale);
      const {status, data} = yield call(getMeetingPolicy, lang);
      if (status === 0) {
        yield put({type: 'update', payload: {meetingPolicy: data || {}}});
      } else {
        console.log('获取会议策略配置失败');
      }
    },
    * getNoticeState(_, {select, call, put}) {
      const lang = yield select(state => state.i18n.locale);
      const {status, data} = yield call(getNoticeState, lang);
      if (status === 0) {
        yield put({type: 'update', payload: {remindTime: data.timeSet || 10}});
      } else {
        console.log('获取会前提醒时间配置失败');
      }
    },
    * getCmmaCospacesBulk(_, {call, put}) {
      // 获取Cospaces Bulk信息
      const {status, data} = yield call(cmmaService.getCospacesBulk);
      if (status === 0) {
        yield put({type: 'update', payload: {cospacesBulk: {...data, available: true}}});
      } else {
        yield put({type: 'update', payload: {cospacesBulk: {available: false}}});
      }
    },
    * syncCmmaCospacesBulk(_, {select, call}) {
      // 同步Cospaces Bulk信息
      const {cospacesBulk} = yield select(state => state.account);
      const {status} = yield call(cmmaService.syncCospacesBulk, {...cospacesBulk});
      if (status === 0) {
        Modal.success({content: '同步成功！请重启meeting服务'})
      } else {
        Modal.error({content: '同步失败！'})
      }
    },
    * saveMeetingPolicy(
      {meetingPolicy, resolve, reject},
      {select, call, put}
    ) {
      const lang = yield select(state => state.i18n.locale);
      const {status, msg} = yield call(accountService.saveMeetingPolicy, {
        meetingPolicy,
        lang
      });
      if (status === 0) {
        yield put({type: 'update', payload: {meetingPolicy}});
        resolve && resolve();
      } else {
        reject && reject(msg);
      }
    },
    * saveRemindTime(
      {remindTime, resolve, reject},
      {select, call, put}
    ) {
      const lang = yield select(state => state.i18n.locale);
      const {status, msg} = yield call(accountService.saveRemindTime, {
        remindTime,
        lang
      });
      if (status === 0) {
        yield put({type: 'update', payload: {remindTime}});
        resolve && resolve();
      } else {
        reject && reject(msg);
      }
    },
    /**
     * 延迟会议信息获取
     * @param undefined
     * @param call
     * @param put
     * @param select
     * @returns {IterableIterator<*>}
     */* getDelayMeeting(undefined, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const meetingId = getUrlParam('meetingId');
      const userId = getUrlParam('userId');
      const domain = userId.indexOf('@') > -1 ? userId.split('@')[1] : '';
      let {data, status} = yield call(getDelayMeetingFun, {
        locale,
        meetingId
      });
      const result = yield call(getDomainInformation, {locale, domain});
      data.emailTitleLogo = result.data.emailTitleLogo;
      yield put({type: 'setDelayMeetingInfor', delayMeetingInfor: data});
      const delayRst = yield call(getMaxDelayTimeFunc, {locale, meetingId});
      if (0 == delayRst.status) {
        const delayArray = delayRst.data.split("|");
        const maxDelay = delayArray.length > 0 ? delayArray[delayArray.length - 1] : 30;
        yield put({type: 'update', payload: {maxDelayTime: delayRst.data, delayTime: maxDelay}});
      }
    },
    /**
     * 延迟会议提交
     * @param params
     * @param call
     * @param put
     * @param select
     * @returns {IterableIterator<*>}
     */
    * delayMeeting(params, {call, put, select}) {
      const userId = getUrlParam('userId');
      const meetingId = getUrlParam('meetingId');
      const locale = yield select(state => state.i18n.locale);
      const data = yield call(delayMeetingFun, {
        ...params,
        locale,
        userId,
        meetingId
      });
      yield put({ type: 'update', payload: { delayMsg: data.msg, delayStatus: data.status } });
      if (data.status === RES_STATUS.success) {
        yield put({ type: 'getDelayMeeting' });
        Modal.success({ content: data.msg });
      } else if (data.status === RES_STATUS.failure) {
        Modal.error({ content: data.msg });
      }
    },
    * saveMaxDelayTime(_, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const maxDelayTime = yield select(state => state.account.maxDelayTime);
      const {messages} = yield select(state => state.i18n);
      const {status, data} = yield call(saveMaxDelayTimeFunc, {locale, maxDelayTime});
      if (0 == status) {
        yield put({type: 'getMaxDelayTime'});
        Modal.success({content: messages['system_manage_delay_time_config_success']});
      } else {
        Modal.error({content: messages['system_manage_delay_time_config_fail']});
      }
    },
    * getMaxDelayTime(_, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const meetingId = -1;
      const {status, data} = yield call(getMaxDelayTimeFunc, {locale, meetingId});
      if (0 == status) {
        yield put({type: 'update', payload: {maxDelayTime: data}});
      }
    },
    * setRoomMaintain({payload, resolve, reject}, {call, select, put}) {
      const {locale} = yield select(state => state.i18n);
      const {roomSelectZoneId} = yield select(state => state.account);
      const {status, msg} = yield call(accountService.setRoomMaintain, {locale, payload});
      if (status === 0) {
        resolve && resolve();
        yield put({type: 'getAllZone'});
        yield put({type: 'getAllZoneWithoutPermission'});
        yield put({type: 'findRooms', payload: {zoneId: roomSelectZoneId}});
      } else {
        reject && reject(msg);
      }
    },
    * findAllBoardVersion({meetingInfo}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const {data, status} = yield call(findAllBoardVersionFnc, {
        locale
      });
      if (status == 0) {
        yield put({type: 'update', payload: {boardVersionList: data}})
      }
    },
    * saveBoardVersion({versionInfo, resolve, reject}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const { userId } = yield select(state => state.login.userInfo);
      versionInfo.createUserId = userId;
      const {status, msg} = yield call(saveBoardVersion, {locale, versionInfo});
      if (status == 0) {
        resolve && resolve();
        yield put({type: 'findAllBoardVersion'});
      } else {
        reject && reject(msg);
      }
    },
    * applyBoardVersion({id, resolve, reject}, {call, put, select}) {
      const locale = yield select(state => state.i18n.locale);
      const { status, msg} = yield call(applyBoardVersion, {id, locale});
      if(status == 0) {
        resolve && resolve();
        yield put({type: 'findAllBoardVersion'});
      } else {
        reject && reject(msg);
        yield put({type: 'findAllBoardVersion'});
      }
    }
  },
  subscriptions: {
    set({dispatch, history}) {
      return history.listen(({pathname}) => {
        if (pathname === PATHS.roomManage) {
          dispatch({type: 'findDeviceLists', types: 0});
          dispatch({type: 'getAllMeetingMangers', types: 1});
          dispatch({type: 'findRooms', payload: {zoneId: 0, name: ''}});
          dispatch({type: 'findCompanyTree'});
          dispatch({type: 'getAllZoneWithoutPermission'});
        } else if (pathname === PATHS.boardManage) {
          dispatch({type: 'getTempSettings'});
          dispatch({type: 'getDisplayboardEnergy'});
          dispatch({type: 'findAllBoardVersion'});
          dispatch({type: 'findRooms', payload: {zoneId: 0, name: ''}});
        } else if (pathname === PATHS.deviceManage) {
          dispatch({type: 'getAllDeviceInfo'});
          dispatch({type: 'getAllZoneWithoutPermission'});
          dispatch({
            type: 'getLendList',
            payload: {current: 1, pageSize: 10}
          });
        } else if (pathname === PATHS.serviceManage) {
          dispatch({type: 'getAllLevels'});
          dispatch({type: 'getAllSvc', payload: {pageNo: 1, pageSize: 10}});
          dispatch({type: 'getAllSvcNoPage'}); //增加等级的服务列表里没有分页，所以这里全查
          dispatch({type: 'getAllSvcType'});
          dispatch({type: 'getAllCleaningPersons'});
        } else if (pathname === PATHS.portManage) {
          dispatch({
            type: 'getExchangeForm',
            payload: {
              currentPage: 1,
              pageSize: 5,
              type: 1,
              status: -1,
              category: 0
            }
          });
        }
        if (pathname === PATHS.log) {
          dispatch({type: 'activityLogs', payload: {}});
        }
        if (pathname === PATHS.workDay) {
          dispatch({type: 'getWeekTime', year: moment().year()});
          dispatch({type: 'getAllHoliday', year: moment().year()});
        }
        if (pathname === PATHS.videoManage) {
          dispatch({
            type: 'getAllMeetingVideo',
            payload: {current: 1, pageSize: 10}
          });
        }
        if (pathname === PATHS.noticeManage) {
          dispatch({type: 'getNoticeManage'});
          dispatch({type: 'getMaxDelayTime'});
          dispatch({type: 'getInfraredCheckTime'});
        }
        if (pathname === PATHS.delayMeeting) {
          dispatch({type: 'getDelayMeeting'});
          let locale = getUrlParam('lang');
          localStorage.setItem('locale', locale);
          if (!locale) {
            if (type == 'Netscape') {
              locale = navigator.language;
            } else {
              locale = navigator.userLanguage;
            }
            locale =
              locale === 'zh' ? 'zh-cn' : locale === 'en' ? 'en-us' : 'zh-cn';
            let sec = locale.split('-');
            sec[1] = sec[1].toUpperCase();
            locale = sec.join('_');
          }
          dispatch({type: 'i18n/setLocale', locale: locale});
        }
        if (
          pathname === PATHS.meetingInfo ||
          pathname === PATHS.meeting ||
          pathname === PATHS.roomManage ||
          pathname === PATHS.list
        ) {
          dispatch({type: 'getMeetingPolicy'});
        }
        if (pathname === PATHS.policy) {
          const token = sessionStorage.getItem('token');
          const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
          if (token && userInfo && userInfo.roleId === 0) {
            dispatch({type: 'getMeetingPolicy'});
            dispatch({type: 'getNoticeState'});
            dispatch({type: 'getCmmaCospacesBulk'});
            dispatch({
              type: 'menu/setMenus',
              menus: {data: INSTALLER_MENU, status: 0}
            });
          } else {
            dispatch({type: 'top/logOff'});
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/account.js